
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.5625',
  depVersions: {
  "embedded-viral-link-ui": "static-1.5625",
  "head-dlb": "static-1.4360",
  "hs-test-utils": "static-1.7351",
  "hubspot-dlb": "static-2.1707",
  "HubStyleTokens": "static-2.10875",
  "I18n": "static-7.1454",
  "jasmine-runner": "static-1.5777",
  "quartz": "static-1.6174",
  "quartz-core": "static-1.5393",
  "react-dlb": "static-1.62",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.603",
  "enviro": "static-4.328",
  "foundations-components": "static-1.6871",
  "history": "static-4.47",
  "hub-http": "static-1.5499",
  "hubspot-url-utils": "static-1.3531",
  "HubStyle": "static-2.11183",
  "icons": "static-2.596",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.6546",
  "PortalIdParser": "static-2.306",
  "quick-fetch": "static-1.2772",
  "react": "static-7.151",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.15967",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.4743",
  "react-virtualized": "static-2.82",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.17607",
  "signup-ui-lego-core": "static-1.19617",
  "styled-components": "static-2.64",
  "StyleGuideUI": "static-3.476",
  "ui-addon-react-router-dom": "static-1.8959",
  "ui-images": "static-2.968",
  "UIComponents": "static-3.7822",
  "usage-tracker": "static-1.6787",
  "usage-tracker-core": "static-1.6637",
  "viral-links-lib": "static-1.6270",
  "hs-promise-rejection-tracking": "static-1.4750",
  "raven": "static-3.5229",
  "raven-hubspot": "static-1.5536",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9058",
  "bend-plugin-trellis-migration": "static-1.2889",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2451",
  "quartz-webpack": "static-1.2398",
  "HeadJS": "static-2.624",
  "framer-motion": "static-1.53",
  "hs-test-utils-bend-plugin": "static-1.2462",
  "msw": "static-1.39",
  "testing-library": "static-1.135",
  "foundations-theming": "static-1.3702",
  "i18n-data": "static-1.208",
  "moment-timezone": "static-5.68",
  "jasmine": "static-4.3668",
  "quartz-core-utils": "static-1.3041",
  "dispatcher": "static-1.122",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.701",
  "hub-http-shared-msw-handlers": "static-1.8464",
  "hubspotter-http": "static-1.4004",
  "hubspotter-http-shared-msw-handlers": "static-1.8462",
  "mobile-manifest-mixins": "static-1.396",
  "platform-navigation-bootstrap": "static-1.11874",
  "ui-fonts": "static-1.334",
  "sassPrefix": "static-1.142",
  "bend-plugin-foundations-components": "static-1.3140",
  "floating-ui": "static-1.41",
  "foundations-assets": "static-1.4216",
  "foundations-theming-specialty": "static-1.1418",
  "hs-story-utils": "static-1.8725",
  "react-aria": "static-1.44",
  "tanstack-table": "static-1.23",
  "superstore": "static-1.4077",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4054",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7438",
  "bender-build-tools": "static-1.2538",
  "bend-plugin-foundations-theming": "static-1.2185",
  "foundations-theming-base": "static-1.2687",
  "ts-schema": "static-1.3532",
  "platform-infra-nav-components": "static-1.7114",
  "hs-lodash": "static-4.45"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.5625",
  "head-dlb": "/head-dlb/static-1.4360",
  "hs-test-utils": "/hs-test-utils/static-1.7351",
  "hubspot-dlb": "/hubspot-dlb/static-2.1707",
  "HubStyleTokens": "/HubStyleTokens/static-2.10875",
  "I18n": "/I18n/static-7.1454",
  "jasmine-runner": "/jasmine-runner/static-1.5777",
  "quartz": "/quartz/static-1.6174",
  "quartz-core": "/quartz-core/static-1.5393",
  "react-dlb": "/react-dlb/static-1.62",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.603",
  "enviro": "/enviro/static-4.328",
  "foundations-components": "/foundations-components/static-1.6871",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5499",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
  "HubStyle": "/HubStyle/static-2.11183",
  "icons": "/icons/static-2.596",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.6546",
  "PortalIdParser": "/PortalIdParser/static-2.306",
  "quick-fetch": "/quick-fetch/static-1.2772",
  "react": "/react/static-7.151",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.15967",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.4743",
  "react-virtualized": "/react-virtualized/static-2.82",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.17607",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19617",
  "styled-components": "/styled-components/static-2.64",
  "StyleGuideUI": "/StyleGuideUI/static-3.476",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8959",
  "ui-images": "/ui-images/static-2.968",
  "UIComponents": "/UIComponents/static-3.7822",
  "usage-tracker": "/usage-tracker/static-1.6787",
  "usage-tracker-core": "/usage-tracker-core/static-1.6637",
  "viral-links-lib": "/viral-links-lib/static-1.6270",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
  "raven": "/raven/static-3.5229",
  "raven-hubspot": "/raven-hubspot/static-1.5536",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9058",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2889",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2451",
  "quartz-webpack": "/quartz-webpack/static-1.2398",
  "HeadJS": "/HeadJS/static-2.624",
  "framer-motion": "/framer-motion/static-1.53",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2462",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.135",
  "foundations-theming": "/foundations-theming/static-1.3702",
  "i18n-data": "/i18n-data/static-1.208",
  "moment-timezone": "/moment-timezone/static-5.68",
  "jasmine": "/jasmine/static-4.3668",
  "quartz-core-utils": "/quartz-core-utils/static-1.3041",
  "dispatcher": "/dispatcher/static-1.122",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.701",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8464",
  "hubspotter-http": "/hubspotter-http/static-1.4004",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8462",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.396",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11874",
  "ui-fonts": "/ui-fonts/static-1.334",
  "sassPrefix": "/sassPrefix/static-1.142",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3140",
  "floating-ui": "/floating-ui/static-1.41",
  "foundations-assets": "/foundations-assets/static-1.4216",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1418",
  "hs-story-utils": "/hs-story-utils/static-1.8725",
  "react-aria": "/react-aria/static-1.44",
  "tanstack-table": "/tanstack-table/static-1.23",
  "superstore": "/superstore/static-1.4077",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4054",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7438",
  "bender-build-tools": "/bender-build-tools/static-1.2538",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2185",
  "foundations-theming-base": "/foundations-theming-base/static-1.2687",
  "ts-schema": "/ts-schema/static-1.3532",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7114",
  "hs-lodash": "/hs-lodash/static-4.45"
}
};
